import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule, registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { AgmCoreModule } from "@agm/core";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxCurrencyModule } from "ngx-currency";

/* Componentes */
import { FormDebugComponent } from "./components/form-debug/form-debug.component";
import { ContatoFormComponent } from "./components/contato/contato.component";
import { ContatoPanelFormComponent } from "./components/contato-panel/contato-panel.component";
import { ConsultaPreviaRepresentantePfFormComponent } from "./components/consulta-previa-representante-pf/consulta-previa-representante-pf.component";
import { UfFormComponent } from "./components/uf/uf.component";
import { VerticalTimelineComponent } from "./components/vertical-timeline/vertical-timeline.component";
import { PaisFormComponentComponent } from "./components/pais/pais.component";
import { MunicipioFormComponent } from "./components/municipio/municipio.component";
import { StatementResponsibilityComponent } from "./components/statement-responsibility/statement-responsibility.component";
import { MessagesComponent } from "./messages/messages.component";
import { PaginationFormComponent } from "./components/pagination/pagination.component";
import { PaginationSizeFormComponent } from "./components/pagination-size/pagination-size.component";
import { EnderecoFormComponent } from "./components/endereco/endereco.component";
import { PagesFilterComponent } from "./components/pages-filter/pages-filter.component";
import { WizardComponent } from "./components/wizard-steps/wizard.component";
import { WizardStepComponent } from "./components/wizard-steps/wizard-step.component";

/* Diretivas */
import { SwMaskDirective } from "./diretivas/mask-sw/mask-sw.directive";
import { ButtonFadeinDirective } from "./diretivas/fade-in-scroller.directive";
import { HasAuthorizationDirective } from "./diretivas/has-authorization/has-authorization.directive";
import { DirectivesModule } from "../theme/directives/directives.module";
import { RemoveSpecialCharactersDirective } from "./diretivas/remove-special-characters/remove-special-characters.directive";
import { OnlyNumbersDirective } from "./diretivas/only-numbers/only-numbers.directive";
import { ToUpperCaseDirective } from "./diretivas/to-upper-case/to-upper-case.directive";
import { RemoveNumbersDirective } from "./diretivas/remove-numbers/remove-numbers.directive";
import { CopyClipboardDirective } from "./diretivas/copyClipboard/copy-clipboard-directive";

/* Serviços */
import { LoggerService } from "./services/logger.service";
import { PluginAssinaturaService } from "./services/plugin-assinatura.service";
import { ConsultaPreviaService } from "./services/consulta-previa.service";
import { DownloadService } from "./services/download.service";
import { GeoLocalizacaoService } from "./services/geo-localizacao.service";
import { IbgeService } from "./services/ibge.service";
import { FloaterButtonsService } from "./services/floater-buttons.service";
import { PaginationSizeService } from "./services/pagination-size.service";
import { PagesFilterService } from "./components/pages-filter/pages-filter.service";
import { ConsultaCepService } from "./services/consulta-cep.service";
import { PagesFilterStorageService } from "./services/pages-filter-storage.service";
import { FilterFormValidatorService } from "./services/filter-form-validator.service";
import { DashboardService } from "../pages/dashboard/dashboard.service";
import { EndpointLocationProviderService } from "./services/endpoint-location-provider.service";
import { DropdownListService } from "./services/dropdownlist.service";
import { UserPreferenceService } from "./services/user-preference.service";

/* Pipes */
import { FilterByPipe } from "../shared/pipes/filterBy.pipe";
import { CnpjPipe } from "../shared/pipes/cnpj.mask.pipe";
import { CepPipe } from "./pipes/cep.mask.pipe";
import { CpfPipe } from "./pipes/cpf.mask.pipe";
import { CpfCnpjPipe } from "./pipes/cpf-cnpj.mask.pipe";
import { ReplaceFileName } from "./pipes/replaceFileName.pipe";
import { PrettyPrintPipe } from "./pipes/json-pretty.pipe";
import { TelephonePipe } from "./pipes/telephone.pipe";
import { CustomDatePipe } from "./pipes/custom-date.pipe";

/* Bootstrap */
import { NotificationService } from "./services/notification.service";
import {
  NgbModule,
  NgbTooltipModule,
  NgbPopoverModule,
} from "@ng-bootstrap/ng-bootstrap";
import { FilterARByACPipe } from "./pipes/filterARByAC.pipe";
import { MultiselectDropdownModule } from "angular-2-dropdown-multiselect";
import { ContatoComercialService } from "./services/contato-comercial.service";
import { GerarSolicitacaoComponent } from "./components/gerar-solicitacao/gerar-solicitacao.component";
import { AgendamentoWebComponentContainerComponent } from "./components/agendamento-webcomponent-container/agendamento-webcomponent-container";
import { ProdutoCatalogoComponent } from "./components/produto-catalogo/produto-catalogo.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

registerLocaleData(localePt);

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DirectivesModule,
    PdfViewerModule,
    SweetAlert2Module.forRoot(),
    AgmCoreModule,
    NgbModule,
    NgxChartsModule,
    NgxCurrencyModule,
    MultiselectDropdownModule,
  ],
  declarations: [
    StatementResponsibilityComponent,
    PagesFilterComponent,
    FormDebugComponent,
    ContatoFormComponent,
    EnderecoFormComponent,
    ContatoPanelFormComponent,
    ConsultaPreviaRepresentantePfFormComponent,
    UfFormComponent,
    VerticalTimelineComponent,
    PaisFormComponentComponent,
    MunicipioFormComponent,
    GerarSolicitacaoComponent,
    AgendamentoWebComponentContainerComponent,
    SwMaskDirective,
    RemoveSpecialCharactersDirective,
    OnlyNumbersDirective,
    ToUpperCaseDirective,
    RemoveNumbersDirective,
    CopyClipboardDirective,
    HasAuthorizationDirective,
    ButtonFadeinDirective,
    CnpjPipe,
    CepPipe,
    CpfPipe,
    FilterByPipe,
    FilterARByACPipe,
    CpfCnpjPipe,
    PrettyPrintPipe,
    TelephonePipe,
    CustomDatePipe,
    MessagesComponent,
    PaginationFormComponent,
    PaginationSizeFormComponent,
    ReplaceFileName,
    WizardComponent,
    WizardStepComponent,
    ProdutoCatalogoComponent,
  ],
  exports: [
    //FloatingActionMenuModule,
    StatementResponsibilityComponent,
    PagesFilterComponent,
    FormDebugComponent,
    ContatoFormComponent,
    EnderecoFormComponent,
    ContatoPanelFormComponent,
    ConsultaPreviaRepresentantePfFormComponent,
    UfFormComponent,
    VerticalTimelineComponent,
    PaisFormComponentComponent,
    MunicipioFormComponent,
    GerarSolicitacaoComponent,
    AgendamentoWebComponentContainerComponent,
    SwMaskDirective,
    RemoveSpecialCharactersDirective,
    OnlyNumbersDirective,
    ToUpperCaseDirective,
    RemoveNumbersDirective,
    CopyClipboardDirective,
    HasAuthorizationDirective,
    ButtonFadeinDirective,
    CnpjPipe,
    CepPipe,
    CpfPipe,
    FilterByPipe,
    FilterARByACPipe,
    CpfCnpjPipe,
    PrettyPrintPipe,
    TelephonePipe,
    CustomDatePipe,
    MessagesComponent,
    PaginationFormComponent,
    PaginationSizeFormComponent,
    NgbTooltipModule,
    NgbPopoverModule,
    NgxChartsModule,
    ReplaceFileName,
    DirectivesModule,
    WizardComponent,
    WizardStepComponent,
    ProdutoCatalogoComponent,
    MultiselectDropdownModule,
  ],
  providers: [
    UserPreferenceService,
    DropdownListService,
    PagesFilterService,
    LoggerService,
    ConsultaPreviaService,
    PluginAssinaturaService,
    DownloadService,
    ConsultaCepService,
    IbgeService,
    GeoLocalizacaoService,
    ContatoComercialService,
    NotificationService,
    FloaterButtonsService,
    PaginationSizeService,
    PagesFilterStorageService,
    DashboardService,
    FilterFormValidatorService,
    EndpointLocationProviderService,
    CpfCnpjPipe,
    [
      {
        provide: LOCALE_ID,
        useValue: "pt-BR",
      },
    ],
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
